//paged fix
jQuery('#form_stories_pagination .pagination .page-numbers').click(function(e){
    e.preventDefault();  

    var href = jQuery(this).attr('href');
    jQuery('#form_stories_paged').val(href);

  	var form = jQuery('#form_stories_pagination');
	form.submit();
});